<h2 mat-dialog-title>Opciones rápidas</h2>
<mat-dialog-content class="mat-typography">
  <mat-grid-list cols="4" rowHeight="4:4">
    <mat-grid-tile>1</mat-grid-tile>
    <mat-grid-tile>2</mat-grid-tile>
    <mat-grid-tile>3</mat-grid-tile>
    <mat-grid-tile>4</mat-grid-tile>
  </mat-grid-list>
  
</mat-dialog-content>